export default {
    namespaced: true,
    state: {
        show: false, // whether to show the modal
        stacked: false, // whether the modal is stacked over another
        icon: null, // material icon name: check_circle, warning, error, etc.
        icon_color: null, // color for the icon: text-danger, text-success, etc.
        title: '', // Title for the modal 
        detail: '', // Detailed message for the modal,
        prompt: false, // whether to show prompt buttons
        resolve: null, // function to call on confirm/cancel
    },
    mutations: {
        showModal(state, payload) {
            state.show = true
            state.stacked = payload.stacked || false
            state.icon = payload.icon
            state.icon_color = payload.icon_color
            state.title = payload.title
            state.detail = payload.detail
            state.prompt = payload.prompt || false
            state.resolve = payload.onResult || null
        },
        hideModal(state) {
            state.show = false
            state.stacked = false
            state.icon = null
            state.icon_color = null
            state.title = ''
            state.detail = ''
            state.prompt = false
            state.resolve = null
        },
    },
    actions: {
        triggerModal({ commit }, payload) {
            commit('showModal', payload)
        },
        closeModal({ commit }) {
            commit('hideModal')
        },
        respond({ state, commit }, value) {
            const resolve = state.resolve
            commit('hideModal')
            if (resolve) {
                setTimeout(() => resolve(value), 0)
            }
        }
    }
}
